import Encuesta from "./Encuesta";
export default Encuesta;
